import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import { NavigationService } from 'src/services/navigation/navigation.service';
import { Breadcrumb } from 'src/models/navigation/breadcrumb.model';

@Component({
    selector: 'pim-breadcrumbs-navigation',
    templateUrl: './breadcrumbs-navigation.component.html',
    styleUrls: ['./breadcrumbs-navigation.component.sass'],
    standalone: false
})
export class BreadcrumbsNavigationComponent {

	breadcrumbs$: Observable<Breadcrumb[]>;

	constructor(private navigationService: NavigationService) {
		this.breadcrumbs$ = this.navigationService.getBreadcrumbsObservable();
	}


}
